import { isObject, isOriginAllowed, sendMessage } from './utils'
import { sendRecoWidgetTagularEvent } from './tracking'
import { getCookieByName } from 'js/bankrate-utilities'

function receiveMessage(event) {
  const { origin, data } = event

  if (window.env !== 'local' && !isOriginAllowed(origin)) return
  if (!isObject(data) || !data.type) return

  switch (data.type) {
    case 'reco-widget.READY': {
      const token = getCookieByName('BAEAU')

      sendMessage({
        type: 'reco-widget.BOOTSTRAP',
        value: { token }
      })

      break
    }
    case 'reco-widget.HEIGHT_UPDATED': {
      const height = data.value
      const iFrame = document.getElementById('deposits-reco-widget')
      iFrame.style.height = `${height}px`

      break
    }
    case 'reco-widget.RESULTS': {
      // Currently we only want to show results on the
      // Recommendation hub page and the authenticated dashboard,
      // NOT ratetables or articles
      const shouldShowResults = window.location.pathname.match(
        /(\/)?(app\/dashboard|bank-recommendation)(\/)?/g
      )

      if (shouldShowResults) {
        sendMessage({
          type: 'reco-widget.SHOULD_SHOW_RESULTS',
          value: true
        })
      } else {
        sendMessage({
          type: 'reco-widget.SHOULD_SHOW_RESULTS',
          value: false
        })
      }

      break
    }
    case 'reco-widget.TAGULAR_EVENT': {
      sendRecoWidgetTagularEvent(data.value)

      break
    }
  }
}

window.addEventListener('message', receiveMessage, false)
